import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/authStore';
import type { Role } from '@stromo/shared';

interface RequireAuthProps {
  children: React.ReactNode;
  roles?: Role[];
}

export function RequireAuth({ children, roles }: RequireAuthProps) {
  const { token, user } = useAuthStore();
  const location = useLocation();

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/projects" replace />;
  }

  return <>{children}</>;
}
